/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { Keys as e } from "@progress/kendo-react-common";
const i = (s, t, a, r) => {
  if (a)
    return s;
  const n = Math.min(r - 1, Math.max(0, s));
  switch (t) {
    case e.enter:
    case e.space:
    case e.esc:
      return -1;
    case e.up:
    case e.left:
      return n - 1 < 0 ? r - 1 : n - 1;
    case e.down:
    case e.right:
      return n + 1 >= r ? 0 : n + 1;
    case e.home:
      return 0;
    case e.end:
      return r - 1;
    default:
      return s;
  }
};
export {
  i as navigate
};
